module.exports = __webpack_public_path__ + "static/media/brand_logo.4fa82fc9.svg";